import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { Provider } from 'react-redux';
import configureStore from '../../../../redux/configureStore';
import { AllPartsPrintPreview } from './AllPartsPrintPreview';

storiesOf('Docket/Popups/AllPartsPrintPreview', module).add('View', () => (
  <Provider store={configureStore()}>
    <AllPartsPrintPreview
      docketParts={{
        partsToPurchase: 18, // Number of parts that need purchasing, can be greater than number of dockets
        totalParts: 27, // Total number of parts that will be bundled.
        totalCost: 12.4, // Total cost for all purchases
        parts: [1, 2, 3, 4, 5], // List of input Docket numbers ?
        percentage: 99, // Current Step percent complete
        step: 1, // Current Step number
        status: 'done', // loading, done
      }}
      buy={action('Buy')}
      onClose={action('Close Popup')}
      popup={{ show: true }}
      reloadDetails={action('Reload Parts')}
    />
  </Provider>
));



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/AllPartsPrintPreview.stories.jsx